import { Component, ElementRef, EventEmitter, Input, OnInit, AfterViewInit, Output, ViewChild } from '@angular/core';
import { SHARED_MODULES } from '../../../shared.';

@Component({
    selector: 'app-autocomplete-simple',
    templateUrl: './autocomplete-simple.component.html',
    styleUrls: ['./autocomplete-simple.component.scss'],
	imports: [SHARED_MODULES],
    standalone: true
})
export class AutocompleteSimpleComponent implements OnInit, AfterViewInit {
	@ViewChild('input') inputElement: ElementRef;

	options: any[];
	visible_options: any[];
	selected: any = {
		id: null,
		name: ''
	};

	@Input() hideSearch: boolean = false;
	@Input() changeFontFamily: boolean = false;
	@Output('onSelect') selectedEvent: EventEmitter<any> = new EventEmitter<any>();

	constructor() {
	}

	@Input('options') set setOptions(list: any[]) {
		this.options = [...list];
		this.visible_options = [...list];
	}

	filterOptions(value: string) {
		if (!value) {
			this.visible_options = [...this.options];
			return;
		}
		const filterValue = value.toLowerCase();

		this.visible_options = this.options.filter(i => i.full_name.toLowerCase().includes(filterValue));
	}

	ngOnInit() {
	}

	ngAfterViewInit() {
		setTimeout(() => {
			this.inputElement.nativeElement.focus();
		}, 100);
	}

	onSelect(value) {
		this.selectedEvent.emit(value);
	}

	checkValue(value) {
		const user = this.options.find(i => i.full_name === value);

		if (user) this.onSelect(user);
	}
}